import { AppTester } from 'supporting';
import { GtTypesFr } from '../teams/const/GtTypes';

export const MAIN_CAMPUS_ID = 'main';
export const INITIAL_CAMPUS_ID = 'intuitlab-paris';

export const FR_CAMPUS_DOMAINS = [
    { test: () => AppTester.isIntuitParis(), campusType: 'intuitlab-paris' },
    { test: () => AppTester.isIntuitMarseille(), campusType: 'intuitlab-marseille' },
    { test: () => AppTester.isIntuitSaopaulo(), campusType: 'intuitlab-saopaulo' },
    { test: () => AppTester.isIntuitMumbai(), campusType: 'intuitlab-mumbai' },
    { test: () => AppTester.isIntuitKolkata(), campusType: 'intuitlab-kolkata' },
    { test: () => AppTester.isIntuitDubai(), campusType: 'intuitlab-dubai' },
    { test: () => AppTester.isIntuitShanghai(), campusType: 'intuitlab-shanghai' },
] as const;

export const getFrCampusTypeFromDomain = (): string | undefined =>
    FR_CAMPUS_DOMAINS.find(({ test }) => test())?.campusType;

export const isFrCampusSpecificDomain = (): boolean => Boolean(getFrCampusTypeFromDomain());

export const isMainFrDomain = (): boolean => AppTester.isFr() && !isFrCampusSpecificDomain();

export const allowedCampusTypeValues = [MAIN_CAMPUS_ID, ...GtTypesFr.map((item) => item.value)];
import { AppTester } from 'supporting';
import { GtTypesFr } from '../teams/const/GtTypes';

export const MAIN_CAMPUS_ID = 'main';
export const INITIAL_CAMPUS_ID = 'intuitlab-paris';

export const FR_CAMPUS_DOMAINS = [
    { test: () => AppTester.isIntuitParis(), campusType: 'intuitlab-paris' },
    { test: () => AppTester.isIntuitMarseille(), campusType: 'intuitlab-marseille' },
    { test: () => AppTester.isIntuitSaopaulo(), campusType: 'intuitlab-saopaulo' },
    { test: () => AppTester.isIntuitMumbai(), campusType: 'intuitlab-mumbai' },
    { test: () => AppTester.isIntuitKolkata(), campusType: 'intuitlab-kolkata' },
    { test: () => AppTester.isIntuitDubai(), campusType: 'intuitlab-dubai' },
    { test: () => AppTester.isIntuitShanghai(), campusType: 'intuitlab-shanghai' },
] as const;

export const getFrCampusTypeFromDomain = (): string | undefined =>
    FR_CAMPUS_DOMAINS.find(({ test }) => test())?.campusType;

export const isFrCampusSpecificDomain = (): boolean => Boolean(getFrCampusTypeFromDomain());

export const isMainFrDomain = (): boolean => AppTester.isFr() && !isFrCampusSpecificDomain();

export const allowedCampusTypeValues = [MAIN_CAMPUS_ID, ...GtTypesFr.map((item) => item.value)];
